import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_gamify_learning_within_the_funnel~1
			funnel: {
				id: 'ob-gamify-learning-i2',
				locale: ['en'],
			},
		},
	},
]

export default config
